import { IGetOneResponse } from '../util/Types/Generic';
import { ApiService } from './ApiService';
// import { User } from '../Utilis/Types/User';
export class FalService extends ApiService {
  static readonly pathName = '/fal';

  static readonly flux = (body: {
    flowId: string;
    fileUrl: string;
    prompt: string;
    imageSize: string;
    numInferenceSteps: number;
    seed: number;
    guidanceScale: number;
    syncMode: boolean | string;
    numImages: number;
    safetyTolerance: string;
    model: string;
  }): Promise<IGetOneResponse<any>> => {
    return ApiService.post(`${this.pathName}/flux`, body);
  };

  static readonly pro = (body: {
    flowId: string;
    fileUrl: string;
    prompt: string;
    imageSize: string;
    numInferenceSteps: number;
    seed: number;
    guidanceScale: number;
    syncMode: boolean | string;
    numImages: number;
    safetyTolerance: string;
    model: string;
  }): Promise<IGetOneResponse<any>> => {
    return ApiService.post(`${this.pathName}/pro`, body);
  };

  static readonly schnell = (body: {
    flowId: string;
    fileUrl: string;
    prompt: string;
    imageSize: string;
    numInferenceSteps: number;
    seed: number;
    guidanceScale: number;
    syncMode: boolean | string;
    numImages: number;
    safetyTolerance: string;
  }): Promise<IGetOneResponse<any>> => {
    return ApiService.post(`${this.pathName}/schnell`, body);
  };

  static readonly dev = (body: {
    flowId: string;
    fileUrl: string;
    prompt: string;
    imageSize: string;
    numInferenceSteps: number;
    seed: number;
    guidanceScale: number;
    syncMode: boolean | string;
    numImages: number;
    safetyTolerance: string;
  }): Promise<IGetOneResponse<any>> => {
    return ApiService.post(`${this.pathName}/dev`, body);
  };
}
